export default __webpack_public_path__ + "static/media/21.cc685ea3.png";